import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgCalendarIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 8V2.667h2.666V8h26.667V2.667H48V8h8a2.667 2.667 0 0 1 2.666 2.667v42.666A2.667 2.667 0 0 1 56 56H8a2.667 2.667 0 0 1-2.667-2.667V10.667A2.667 2.667 0 0 1 8 8zm0 2.667H8v10.666h48V10.667h-8V16h-2.667v-5.333H18.666V16H16zM56 24H8v29.333h48zm-34.667 8v2.667h-8V32zM36 34.667h-8V32h8zM50.666 32v2.667h-8V32zM21.333 42.667v2.666h-8v-2.666zM36 45.333h-8v-2.666h8zm14.666-2.666v2.666h-8v-2.666z"
    />
  </svg>
)
export default SvgCalendarIcon
